<template>
  <div class="home-page-wrap">
    <header>
      <div class="container">
        <div class="logo-top">fotty</div>
        <div class="right-block">
          <div
            class="login-btn"
            @click="(!user_info.phone)?$router.push({path:'/auth/login'}):$router.push({path:'/profile'})"
          >{{ (!user_info.phone)? 'Войти' : 'Профиль' }}
          </div>

          <div class="app-link-wrap">
            <div class="app appstore">
              <a
                href="https://apps.apple.com/ru/app/fotty-фото-с-вашего-события/id1483048769"
                target="_blank"
              >
                <SvgIcon name="appstore" width="40" height="40"></SvgIcon>
              </a>
            </div>
            <div class="app google-play">
              <a
                href="https://play.google.com/store/apps/details?id=com.adeptum.fotty"
                target="_blank"
              >
              <img src="@/assets/images/google_play.png" alt/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="waved unic-service">
      <div class="container">
        <section class="top-section">
          <h1>{{typograf('Уникальное приложение вашего события в телефоне у каждого гостя')}}</h1>
          <div>{{typograf('Fotty - новый способ для организаторов мероприятий делиться фотографиями, информацией и продавать услуги онлайн')}}
          </div>
          <router-link
            to="/auth/registration/"
            class="btn btn-grad-purp"
            v-if="!$store.state.user.user_info.phone"
          >Создать приложение
          </router-link>
          <router-link to="/events/step/1/" class="btn btn-grad-purp" v-else>Создать приложение</router-link>
        </section>
        <section class="phone-group">
          <img src="@/assets/images/mobiles1.png" alt/>
        </section>
        <section class="bottom-section">
          <div class="cube">
            <img src="@/assets/fotty_square.jpg" alt/>
          </div>
          <h2>{{typograf('Что такое Фотти')}}</h2>
          <div>{{typograf('Это сервис, который соединяет организаторов и фотографа с гостями события. Для каждого ивента — эксклюзивное мобильное приложение, которое доступно только участникам мероприятия. С Fotty каждый гость первым получит пуш с программой события, таймингом. Главное, Fotty первым пришлет уведомления о готовности фотографий.')}}</div>
        </section>
      </div>
    </div>
    <div class="unic unic-advantage">
      <div class="container">
        <div class="mosaic-wrap">
          <div class="mosaic-row">
            <div class="mosaic-block-wrap">
              <div class="mosaic-block mosaic-1">
                <div class="num">01</div>
                <div class="text-wrap">
                  <div class="title">Эксклюзивность</div>
                  <div
                    class="descr"
                  >{{typograf('У гостей будет личное приложение с мероприятия, которым управляет организатор')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="mosaic-block-wrap">
              <div class="mosaic-block mosaic-2">
                <div class="num">02</div>
                <div class="text-wrap">
                  <div class="title">Хранилище</div>
                  <div
                    class="descr"
                  >{{typograf('Не нужно грузить фото на сторонние сервисы, грузи прямо в личное приложение')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mosaic-row full-width">
            <div class="mosaic-block-wrap">
              <div class="mosaic-block mosaic-3">
                <div class="num">03</div>
                <div class="text-wrap">
                  <div class="title">Дизайн</div>
                  <div
                    class="descr"
                  >{{typograf('Выбирай или создавай дизайн приложения под стиль мероприятия')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mosaic-row">
            <div class="mosaic-block-wrap">
              <div class="mosaic-block mosaic-4">
                <div class="num">04</div>
                <div class="text-wrap">
                  <div class="title">Обратная связь и продажи</div>
                  <div
                    class="descr"
                  >{{typograf('C помощью Fotty удобно делать рассылку и увеличивать средний чек')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="mosaic-block-wrap">
              <div class="mosaic-block mosaic-5">
                <div class="num">05</div>
                <div class="text-wrap">
                  <div class="title">Статистика</div>
                  <div
                    class="descr"
                  >{{typograf('Анализируй, сколько гостей готовы купить услуги после или во время события')}}
                  </div>
                </div>
              </div>
              <router-link
                to="/auth/registration/"
                class="btn btn-outline-primary"
                v-if="!$store.state.user.user_info.phone"
              >Регистрация
              </router-link>
              <router-link
                to="/events/step/1/"
                class="btn btn-outline-primary"
                v-else
              >Создать приложение
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="unic unic-feedback">
      <div class="container">
        <h3>{{typograf('Fotty — новый канал привлечение клиентов и обратной связи для организаторов')}}</h3>
        <div class="block-wrap">
          <div class="block">
            <div class="img-wrap">
              <span class="num">1</span>
              <SvgIcon name="blogging" width="96px" height="96px"></SvgIcon>
            </div>
            <div
              class="description"
            >{{typograf('Добавь событие и сервис автоматически создаст приложение')}}
            </div>
          </div>
          <div class="block">
            <div class="img-wrap">
              <span class="num">2</span>
              <SvgIcon name="qrcode" width="96px" height="96px"></SvgIcon>
            </div>
            <div
              class="description"
            >{{typograf('Раздай ссылку уникального приложения на скачивание гостям ')}}
            </div>
          </div>
          <div class="block">
            <div class="img-wrap">
              <span class="num">3</span>
              <SvgIcon name="user" width="96px" height="96px"></SvgIcon>
            </div>
            <div class="description">{{typograf('Каждый гость получит уникальное приложение')}}</div>
          </div>
          <div class="block">
            <div class="img-wrap">
              <span class="num">4</span>
              <SvgIcon name="picture" width="96px" height="96px"></SvgIcon>
            </div>
            <div
              class="description"
            >{{typograf('Загружай и отправляй фото, создавай рекламные посты')}}
            </div>
          </div>
          <div class="block">
            <div class="img-wrap">
              <span class="num">5</span>
              <SvgIcon name="Frame" width="96px" height="96px"></SvgIcon>
            </div>
            <div
              class="description"
            >{{typograf('Каждый гость получит и просмотрит их в приложении')}}
            </div>
          </div>
          <div class="block">
            <div class="img-wrap">
              <span class="num">6</span>
              <SvgIcon name="wallet" width="96px" height="96px"></SvgIcon>
            </div>
            <div
              class="description"
            >{{typograf('Получай обратную связь, общайся и зарабатывай с помощью Fotty')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="unic unic-banner">
      <div class="container">
        <h3>Создай свое первое приложение бесплатно</h3>
        <div>Будь первым организатором в своем городе</div>
        <router-link
          to="/auth/registration/"
          class="btn btn-white"
          v-if="!$store.state.user.user_info.phone"
        >Попробуй бесплатно
        </router-link>
        <router-link to="/events/step/1/" class="btn btn-white" v-else>Создай приложение</router-link>
      </div>
    </div>
    <div class="unic unic-how-it-work">
      <div class="container">
        <h3>Как это работает</h3>
        <div class="work-step-row row">
          <div class="col-5 step-description">
            <div class="descr-wrap">
              <div class="num">
                <img src="@/assets/images/work_step_1.png" alt/>
              </div>
              <h5>{{typograf('Создай и настрой событие в личном кабинете')}}</h5>
              <div
                class="descr"
              >{{typograf('Для каждого события будет своя ссылка и свое мобильное приложение. Регистрация и первое событие бесплатно')}}
              </div>
              <!-- <div class="link">
                Узнать подробнее
                <SvgIcon name="forward" width="8" height="40"></SvgIcon>
              </div>-->
            </div>
          </div>
          <div class="col-7 img-wrap">
            <img src="@/assets/images/imac1.png" alt/>
          </div>
        </div>
        <div class="work-step-row reverse row">
          <div class="col-5 step-description">
            <div class="descr-wrap">
              <div class="num">
                <img src="@/assets/images/work_step_2.png" alt/>
              </div>
              <h5>{{typograf('Распространи ссылку на приложение среди гостей')}}</h5>
              <div
                class="descr"
              >{{typograf('Почему гостям это интересно? Личное приложение — эксклюзив! Персональные скидки в приложении на твои услуги')}}
              </div>
              <!-- <div class="link">
                Узнать подробнее
                <SvgIcon name="forward" width="8" height="40"></SvgIcon>
              </div>-->
            </div>
          </div>
          <div class="col-7 img-wrap">
            <img src="@/assets/images/imac2.png" alt/>
          </div>
        </div>
        <div class="work-step-row row">
          <div class="col-5 step-description">
            <div class="descr-wrap">
              <div class="num">
                <img src="@/assets/images/work_step_3.png" alt/>
              </div>
              <h5>{{typograf('Делись информацией во время события и фото в приложении')}}</h5>
              <div
                class="descr"
              >{{typograf('Новые лояльные клиенты постят фотографии прямо из приложения и заказывают услуги с твоей персональной скидкой')}}
              </div>
              <!-- <div class="link">
                Узнать подробнее
                <SvgIcon name="forward" width="8" height="40"></SvgIcon>
              </div>-->
            </div>
          </div>
          <div class="col-7 img-wrap">
            <img src="@/assets/images/mobiles1.png" alt/>
          </div>
        </div>
      </div>
    </div>
    <div class="unic unic-subscribe">
      <div class="container">
        <div class="subscribe-wrap">
          <h3>{{typograf('Подпишитесь на новости Фотти')}}</h3>
          <div class="descr">
            {{typograf('Пишите на почту для обратной связи на ')}}
            <a
              href="mailto:info@fotty.ru"
            >info@fotty.ru</a>
            <p>
              Или звоните по номеру
              <a href="tel:+74812600131">+7 4812 600-131</a>
            </p>
          </div>
          <div class="subscribe-input">
            <Inputs
              class="input-group"
              type="email"
              placeholder="Электронная почта"
              subholder="Почта"
              name="email"
              ref="email"
            ></Inputs>
            <button class="btn btn-grad-purp" @click="subscribe">Подписаться</button>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <div class="footer">
        <div class="container">
          <div class="logo-bottom">fotty</div>
          <div class="right-block">
            <div class="app-wrap">
              <div class="app">
                <a
                  href="https://www.instagram.com/fottyapp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="@/assets/images/insta.png" alt/>
                </a>
              </div>
              <div class="app">
                <a href="https://vk.com/fottyapp" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/images/vk.png" alt/>
                </a>
              </div>
              <div class="app">
                <a
                  href="https://www.facebook.com/groups/fotty/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="@/assets/images/fb.png" alt/>
                </a>
              </div>
              <div class="app">
                <a
                  href="https://apps.apple.com/ru/app/fotty-фото-с-вашего-события/id1483048769"
                  target="_blank"
                >
                  <img src="@/assets/images/appstore.png" alt/>
                </a>
              </div>
              <!-- <div class="app">
              <img src="@/assets/images/google_play.png" alt />
              </div>-->
            </div>
            <div class="login-btn"
                 @click="(!user_info.phone)?$router.push({path:'/auth/login'}):$router.replace({path:'/profile'})"
            >{{ (!user_info.phone)? 'Войти' : 'Профиль' }}
            </div>
          </div>
        </div>
      </div>
      <div class="sub-footer">
        <div class="container">
          <div class="sub-footer-wrp">
            <div class="link-wrap">
            <span class="link">
              <router-link to="/privacy/" target="_blank">Политика конфиденциальности</router-link>
            </span>
            <span class="link">
              <a href="https://vk.com/im?sel=-187939287" target="_href">Поддержка</a>
            </span>
            <span class="link">
              <router-link to="/terms/" target="_blank">Соглашение</router-link>
            </span>
            <span class="copy-right">Все права защищены ©</span>
          </div>
            <div class="app-wrap">
            <img src="@/assets/images/payments.png" class="payments-logo"/>
            <!-- <div class="app">
              <img src="@/assets/images/google_play.png" alt />
            </div>-->
          </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import Typograf from 'typograf'
  import Inputs from '@/components/basic/Input.vue'
  import { mapGetters } from 'vuex'
  import Subscribe from '@/services/Subscribe'

  var tp = new Typograf({locale: ['ru', 'en-US']})
  export default {
    name: 'Landing',
    components: {
      Inputs
    },
    methods: {
      typograf: function (text = '') {
        return tp.execute(text)
      },
      successSubscribe: function () {
        this.$notify({
          group: 'success',
          title: 'Отлично!',
          text: 'Подписка успешно оформлена'
        })
      },
      errorSubscribe: function (response) {
        this.$notify({
          group: 'error',
          title: 'Ошибка',
          text: response.data.message
        })
      },
      subscribe: function () {
        let mail = this.$refs.email.getValue() || ''
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (!pattern.test(mail)) {
          this.$notify({
            group: 'error',
            title: 'Ошибка',
            text: 'Введен некорректный email'
          })

          return
        }

        Subscribe.subscribe({email: mail})
          .then(this.successSubscribe)
          .catch(error => {
            this.errorSubscribe(error.response)
          })
      }
    },
    computed: {
      ...mapGetters({
        user_info: 'user/get_user'
      })
    },
    mounted() {
      this.$store.dispatch('user/auth')
    }
  }
</script>

<style lang="scss" scope>
  .container,
  .container-fluid {
    @media (max-width: $mobileSize) {
      min-width: 100% !important;
    }
    min-width: 960px;
  }
  .btn-grad-purp {
    @extend %bRadius;
    background: linear-gradient(
        171.51deg,
        #715ed5 0%,
        #4834af 57.55%,
        #291786 100%
    );
    color: #fff !important;
    font-weight: 600 !important;
    font-size: 20px !important;
    line-height: 24px !important;
    padding: 19px 38px !important;
    @media (max-width: $mobileSize) {
      width: 100%;
    }

    &:hover {
      // background: linear-gradient(
      //   188.49deg,
      //   #715ed5 0%,
      //   #4834af 57.55%,
      //   #291786 100%
      // );
      color: #fff;
    }
  }

  .home-page-wrap {
    .col-5 {
      @media (max-width: $mobileSize) {
        flex: 0 !important;
        max-width: 100% !important;
      }
    }
    .col-7 {
      @media (max-width: $mobileSize) {
        flex: 0 !important;
        max-width: 100% !important;
      }
    }
    header,
    .footer {
      background: #333;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);

      .container {
        padding: 16px 0;
        align-items: center;
        color: #fff;
        display: flex;
        justify-content: space-between;

        .logo-top {
          font-weight: 900;
          font-size: 32px;
          line-height: 40px;
        }

        .logo-bottom {
          @media (min-width: $mobileSize) {
            display: block;
          }
          display: none;
          font-weight: 900;
          font-size: 32px;
          line-height: 40px;
        }

        .right-block {
          display: grid;
          grid-template-columns: 116px 88px;
          grid-column-gap: 8px;

          .login-btn {
            text-align: center;
            padding: 8px 20px;
            @include border(#fff);
            cursor: pointer;
          }

          .app-link-wrap {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 8px;

            .app {
              svg,
              img {
                width: 40px;
                height: 40px;
              }
            }
          }
        }
      }
    }

    footer {
      .footer {
        border-bottom: none;

        .right-block {
          display: flex !important;
          align-items: center;
          @media (max-width: $mobileSize) {
            justify-content: space-between;
            width: 100%;
          }
          .app-wrap {
            margin-right: 16px;
          }
        }
      }

      .sub-footer {
        background: #eeeeee;
        @media (min-width: $mobileSize) {
          height: 72px;
        }

        .container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          .sub-footer-wrp {
            display: flex;
            flex-direction: column-reverse;
            align-items: center;
            text-align: center;
            width: 100%;

            @media (min-width: $mobileSize) {
              width: 100%;
              flex-direction: row;
              justify-content: space-between;
            }

            .link-wrap {
              display: flex;
              flex-direction: column;
              @media (min-width: $mobileSize) {
                flex-direction: row;
                align-items: center;
              }
              font-size: 14px;
              line-height: 20px;
              color: #333;

              span {
                @media (min-width: $mobileSize) {

                  &:not(:last-child) {
                    margin-right: 24px;
                  }
                }
                &.copy-right {
                  color: #8e8e8e;
                }
              }
            }
          }
        }
      }
    }

    .app-wrap {
      display: flex;

      img {
        max-height: 40px;
      }

      .app {
        &:not(:last-child) {
          margin-right: 8px;
        }

        img {
          width: 40px;
          height: 40px;
        }
      }
    }

    .waved {
      position: relative;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 175px;
        background: url("~@/assets/images/wave_bg.png");
        // background-size: cover!important;
        background-position-y: 101%;
        background-repeat: no-repeat;
        background-size: 100%;
      }
    }

    .unic-service {
      padding: 82px 146px 130px;
      @media (max-width: 1190px) {
        padding: 82px 0 130px;
      }
      background: #333;
      color: white;

      .btn-grad-purp {
        border-color: #333;
      }

      section {
        text-align: center;
        margin-bottom: 80px;

        h1,
        h2 {
          font-size: 44px;
          line-height: 56px;
          margin-bottom: 56px;
        }

        h1 {
          font-weight: 800;
        }

        h2 {
          font-weight: 700;
        }

        div {
          font-weight: 500;
            font-size: 20px;
            line-height: 32px;
          opacity: 0.7;
          margin-bottom: 56px;
        }
      }

      .phone-group {
        width: 100%;
        height: auto;
        @media (min-width: 1190px) {
          height: 588px;
        }
        position: relative;
        margin-bottom: 80px;

        &::after {
          content: "";
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 0;
          height: 100%;
          background: linear-gradient(
              180deg,
              rgba(51, 51, 51, 0) 0%,
              #333333 100%
          );
        }

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .bottom-section {
        margin-bottom: 0 !important;

        .cube {
          $side: 64px;
          width: $side;
          height: $side;

          img {
            max-width: 100%;
          }

          @include border(#333);
          overflow: hidden;
          margin: 0 auto;
          // background: linear-gradient(
          //     135deg,
          //     #715ed5 0%,
          //     #4834af 57.55%,
          //     #291786 100%
          //   ),
          //   linear-gradient(135deg, #8371e4 0%, #4834af 57.55%, #291786 100%);
          margin-bottom: 16px;
        }

        h2 {
          margin-bottom: 32px !important;
        }

        div {
          margin: 0 auto;
        }
      }
    }

    .unic {
      @media (min-width: $mobileSize) {
        padding: 96px 0;
      }
      padding: 48px 0;

      h3 {
        font-weight: bold;
        font-size: 56px;
        line-height: 64px;
        @media (max-width: $mobileSize) {
          font-size: 38px;
          line-height: 46px;
        }
        margin-bottom: 80px;
      }
    }

    .unic-advantage {
      @media (min-width: $mobileSize) {
        padding: 96px 0;
      }
      padding: 0;
      .mosaic-wrap {
        .mosaic-row {
          @media (max-width: $mobileSize) {
            display: block;
          }
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 16px;
          margin-bottom: 16px;
          @media (max-width: $mobileSize) {
            margin-bottom: 0;
          }
          &.full-width {
            grid-template-columns: 1fr;

            .mosaic-block-wrap {
              .mosaic-block {
                display: grid;
                grid-template-columns: 1fr 1fr;
                min-height: auto;
              }
            }
          }
        }

        .mosaic-block-wrap {
          .btn {
            margin-top: 16px;
            width: 100%;
            padding: 19px 0;
            font-weight: 600;
              font-size: 20px;
              line-height: 24px;
          }

          .mosaic-block {
            &.mosaic-1 {
              background: url("~@/assets/images/mosaic01.png");
            }

            &.mosaic-2 {
              background: url("~@/assets/images/mosaic02.png");
            }

            &.mosaic-3 {
              background: linear-gradient(
                  167.46deg,
                  #715ed5 0%,
                  #4834af 57.55%,
                  #291786 100%
              ),
              linear-gradient(
                  180deg,
                  rgba(0, 0, 0, 0.1) 0%,
                  rgba(0, 0, 0, 0.8) 100%
              );
            }

            &.mosaic-4 {
              background: url("~@/assets/images/mosaic04.png");
            }

            &.mosaic-5 {
              background: #1c6c99;
            }

            background-repeat: no-repeat;
            background-size: 100% !important;
            @include border(#fff);
            padding: 24px 32px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #fff;
            min-height: 464px;
            height: 100%;

            .num {
              font-weight: bold;
              font-size: 64px;
              line-height: 76px;
            }

            .text-wrap {
              .title {
                margin-bottom: 14px;
                font-weight: bold;
                font-size: 28px;
                line-height: 34px;
                @media (min-width: $mobileSize) {
                  font-size: 32px;
                }
              }

              .descr {
                font-weight: 500;
                  font-size: 20px;
                  line-height: 32px;
              }
            }
          }
        }
      }
    }

    .unic-feedback {
      .block-wrap {
        @media (min-width: $mobileSize) {
          display: grid;
          grid-template-columns: 260px 260px 260px;
          grid-column-gap: 90px;
          grid-row-gap: 40px;
        }
        display: flex;
        flex-direction: column;

        .block {
          margin-bottom: 40px;
          @media (min-width: $mobileSize) {
            margin-bottom: 0;
          }
          .img-wrap {
            @media (min-width: $mobileSize) {
              width: 100%;
            }
            position: relative;

            svg {
              position: absolute;
              bottom: 30px;
              right: calc(50% - 48px);
            }

            .num {
              font-weight: 500;
              font-size: 200px;
              line-height: 200px;
              color: #333;
              opacity: 0.07;
            }
          }

          .description {
              font-size: 20px;
              line-height: 28px;
            font-weight: 600;
            color: #333;
          }
        }
      }
    }

    .unic-banner {
      background: url("~@/assets/images/createAppBg.png");
      background-size: cover !important;
      background-repeat: no-repeat;
      text-align: center;
      color: #fff;
      padding: 80px 0;
      @media (max-width: $mobileSize) {
        margin-bottom: 40px;
      }

      h3 {
        margin-bottom: 34px;
      }

      div {
        &:not(.container) {
          font-weight: 500;
            font-size: 20px;
            line-height: 32px;
          margin-bottom: 40px;
        }
      }

      .btn-white {
        color: #cc2a74 !important;
        padding: 20px 48px;
        background: #fff;
        @include border(#fff);
        @media (max-width: $mobileSize) {
          width: 100%;
        }
        }
    }

    .unic-how-it-work {
      @media (min-width: $mobileSize) {
        padding: 160px 0;
      }
      padding: 0;

      .work-step-row {
        display: flex;
        align-items: center;
        flex-direction: column;
        @media (min-width: $mobileSize) {
          flex-direction: row;
          margin-bottom: 156px;
        }

        flex-wrap: wrap;
        margin-bottom: 56px;

        &.reverse {
          @media (min-width: $mobileSize) {
            flex-direction: row-reverse;
          }
          .descr-wrap {
            @media (min-width: $mobileSize) {
              margin-left: auto;
            }
          }
        }

        .step-description {
          .num {
            width: 112px;
            height: 98px;

            img {
              max-width: 100%;
            }

            margin-bottom: 48px;
          }

          .descr-wrap {
            @media (min-width: $mobileSize) {
              max-width: 304px;
            }
            max-width: 100%;

            h5 {
              @media (max-width: $mobileSize) {
                font-size: 24px;
                line-height: 34px;
              }
              font-weight: 600;
              font-size: 44px;
              line-height: 54px;
              margin-bottom: 16px;
            }

            .descr {
              font-weight: 500;
              font-size: 20px;
              line-height: 32px;
              @media (min-width: $mobileSize) {
                margin-bottom: 16px;
              }
              margin-bottom: 48px;
              opacity: 0.7;
            }

            .link {
              cursor: pointer;
              font-weight: 500;
                font-size: 20px;
                line-height: 32px;
              color: #301c99;

              svg {
                margin-left: 2px;
              }
            }
          }
        }

        .img-wrap {
          display: grid;

          img {
            @media (min-width: $mobileSize) {
              max-width: 544px;
            }
            max-width: 100%;
            align-self: self-end;
          }
        }
      }
    }

    .unic-subscribe {
      background: #f7f7f7;

      .subscribe-wrap {
        @media (min-width: $mobileSize) {
          max-width: 637px;
        }
        width: 100%;

        h3 {
          margin-bottom: 24px;
        }

        .descr {
          margin-bottom: 48px;
          font-weight: 500;
            font-size: 20px;
            line-height: 32px;
        }
      }

      .subscribe-input {
        display: flex;
        @media (max-width: $mobileSize) {
          width: 100%;
          flex-direction: column;
        }

        .input-line {
          width: 100%;
          padding-right: 24px;
          @media (max-width: $mobileSize) {
            margin-bottom: 24px;
            padding-right: 0;
          }
        }

        input {
          padding: 19px 20px;
        }
      }
    }
  }
</style>
